export enum SIGNUP_API_CODE_NAMES {
  EMAIL_ALREADY_EXISTS = "4001",
  MOBILE_VERIFIED_ANOTHER_ACCOUNT = "4002",
  MOBILE_EXISTS_ANOTHER_ACCOUNT = "4003",
  OTP_REQUIRED = "4004",
  MOBILE_REQUIRED = "4005",
  MISSING_FIELDS_REQUIRED = "4009",
  GUEST_ALREADY_REGISTERED = "4010",
  LOGGED_IN_DIFFERENT_ACCOUNT = "4011",
  MOBILE_ALREADY_USED_IN_ANOTHER_ACCOUNT = "4006"
}
export const SIGNUP_CODES_FOR_MODAL = {
  4004: "4004",
  4006: "4006"
};

export const SIGNUP_API_CODE_INDEX = {
  VERIFY_OTP: 0
};

export const MODAL_STEPS = {
  4004: SIGNUP_API_CODE_INDEX.VERIFY_OTP
};

export const SOCIAL_SIGNUP_MODES = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
  APPLE: "apple"
};

export const DRAFT_STORAGE_KEY = "updateDetailsFormDraft";
